// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API_KEY } from '@app/core/environment.configuration';

import { ProjectDetail } from '@app/core/models';

@Injectable()
export class ProjectsService {
  constructor(private httpClient: HttpClient, @Inject(API_KEY) private api: string) {}

  public get(projectId: string): Observable<ProjectDetail> {
    const route = `${this.api}/projects/${projectId}`;
    return this.httpClient.get<ProjectDetail>(route);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/projects.service.ts